import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Button from '../utility/Button';
import { withTranslation } from 'react-i18next';

import { parseMoney, paxParser, lastOf } from '../../js/utility';
import { receiveByorIsMemberResponse } from '../../actions/booking';

class PriceSummary extends Component {
  constructor(props) {
    super(props);
    this.handlePressEnter = this.handlePressEnter.bind(this);
  }

  handlePressEnter(e) {
    if (e.key === 'Enter') {
      this.props.applyCode();
    }
  }

  adultPax(bookingPax) {
    return bookingPax.adult ? bookingPax.adult : bookingPax;
  }

  render() {
    const {
      isLoading,
      isConfirmed,
      bookingPrice,
      bookingPax,
      applyCode,
      promoCode,
      handleChange,
      currentTrip,
      t,
      isByAge,
      isByPax,
      isPerTrip
    } = this.props;

    const totalPax =
      typeof bookingPax !== 'number'
        ? bookingPax.adult + bookingPax.child
        : bookingPax;

    const discountStr = bookingPrice.discountType
      ? bookingPrice.discountType === 'percentage'
        ? parseFloat(bookingPrice.discount) * 100 + '%'
        : `RM ${parseMoney(parseFloat(bookingPrice.discount))}`
      : '';


    let newestPromo = {};

    if (bookingPrice.promos) {
      newestPromo = lastOf(bookingPrice.promos) ? ((lastOf(bookingPrice.promos).promoCode === 'TRUE') ? {} : lastOf(bookingPrice.promos)) : {};
    }

    let tempPrice = (bookingPrice.taxAmount === null) ? bookingPrice.price : null;

    if (bookingPrice.taxAmount === null){
      // Include insurance, SST, & service fee
      const insurance = parseFloat(process.env.INSURANCE_AMOUNT);
      const sstPercentage = parseFloat(process.env.TAX_PERCENTAGE)/100;
      const serviceFee = parseFloat(process.env.SST_PERCENTAGE)/100;

      tempPrice = tempPrice + (insurance * totalPax);
      tempPrice = tempPrice + (tempPrice * serviceFee);
      tempPrice = tempPrice + (tempPrice * sstPercentage);
    }

    bookingPrice.child_rate != null
      ? (bookingPrice.child_rate = bookingPrice.child_rate)
      : (bookingPrice.child_rate = '0.00');

    return (
      <>
        <div className='fe-menu-summary'>
          <div className='fe-menu-summary-heading'>
            {t('form:priceSummary')}
          </div>
          <div className='fe-menu-summary-price'>
            {isLoading ? (
              <div className='fe-menu-summary-price-item'>
                {t('gen:loading')}...
              </div>
            ) : (
              <>
                {bookingPrice.parking ? (
                  <div className='fe-menu-summary-price-item'>
                    <span>{t('gen:parking')}</span>
                    <span>RM {parseMoney(bookingPrice.parking)}</span>
                  </div>
                ) : null}
                <div className='fe-menu-summary-price-item'>
                  {isByAge || isByPax ? (
                    <span>
                      {t('gen:getawayPrice')}{' '}
                      {/* <br /> */}
                      {'('}{bookingPax.adult || bookingPax || 0}&nbsp;
                      {!bookingPax.child
                        ? t('gen:pax')
                        : bookingPax.adult !== 1
                        ? t('gen:paxAdults')
                        : t('gen:paxAdult')}
                      {/* &nbsp; (
                      {t('gen:pricePerPax', {
                        price: isByAge
                          ? `RM ${parseMoney(bookingPrice.priceByAge.adult)}`
                          : `RM ${parseMoney(
                              bookingPrice.adult_rate[
                                paxParser(this.adultPax(bookingPax))
                              ] / this.adultPax(bookingPax)
                            )}`
                      })}
                      )<br /> */}
                      {bookingPax.child ? (
                        <>
                        &nbsp;
                          {bookingPax.child || 0}&nbsp;
                          {bookingPax.child !== 1
                            ? t('gen:paxChildren')
                            : t('gen:paxChild')}
                          {/* &nbsp; (
                          {t('gen:pricePerPax', {
                            price: isByAge
                              ? `RM ${parseMoney(
                                  bookingPrice.priceByAge.child
                                )}`
                              : `RM ${parseMoney(
                                  bookingPrice.child_rate[
                                    paxParser(bookingPax.child)
                                  ] / bookingPax.child || 0
                                )}`
                          })}
                          )<br /> */}
                        </>
                      ) : null}
                      {')'}
                    </span>
                  ) : (
                    <span>
                      {t('gen:getawayPrice')}
                      <br />
                      {totalPax}&nbsp;
                      {t('gen:pax')}&nbsp;
                      {isPerTrip ? null : (
                        <>
                          (
                          {t('gen:pricePerPax', {
                            price: `RM ${parseMoney(bookingPrice.pricePerPax)}`
                          })}
                          )
                        </>
                      )}
                    </span>
                  )}
                  <span>RM {parseMoney(tempPrice || bookingPrice.price)}</span>
                </div>

                {
                  bookingPrice.taxAmount !== null ? (
                    <>
                      {bookingPrice.discount ? (
                        <>
                          {
                            <div className='fe-menu-summary-price-item'>
                              <span>{t('form:discount')}</span>
                              <span>
                                - RM{' '}
                                {parseMoney(bookingPrice.discount)}
                              </span>
                            </div>
                          }
                        </>
                      ) : null}
                      {/* {bookingPrice.discount ? (
                        <div className='fe-menu-summary-price-item'>
                          <span>{`${discountStr} ${t('gen:discount')}`}</span>
                          <span>- RM {parseMoney(bookingPrice.deduction)}</span>
                        </div>
                      ) : null} */}
                      {(bookingPrice.promos || []).map(obj => {
                        return obj.promoValid ? (
                          <div
                            key={obj.promoCode}
                            className='fe-menu-summary-price-item'
                          >
                            <span className='fe-menu-summary-price-item-promo-desc'>
                              {`${obj.desc || t('form:promoCode')} (${
                                obj.promoCode
                              })`}
                            </span>
                            <span>- RM {parseMoney(obj.discountAmount)}</span>
                          </div>
                        ) : null;
                      })}
                      <div className="fe-menu-summary-price-item">
                        <span>
                          {t('form:insurance')}{' '}
                          {/* <br /> */}
                          {'('}{bookingPax.adult || bookingPax || 0}&nbsp;
                          {!bookingPax.child
                            ? t('gen:pax')
                            : bookingPax.adult !== 1
                              ? t('gen:paxAdults')
                              : t('gen:paxAdult')
                          }
                          {/* &nbsp; (
                          {t('gen:pricePerPax', {
                            price: isByAge
                              ? `RM ${parseMoney(bookingPrice.priceByAge.adult)}`
                              : `RM ${parseMoney(
                                  bookingPrice.adult_rate[
                                    paxParser(this.adultPax(bookingPax))
                                  ] / this.adultPax(bookingPax)
                                )}`
                          })}
                          )<br /> */}
                          {bookingPax.child ? (
                            <>
                            &nbsp;
                              {bookingPax.child || 0}&nbsp;
                              {bookingPax.child !== 1
                                ? t('gen:paxChildren')
                                : t('gen:paxChild')}
                              {/* &nbsp; (
                              {t('gen:pricePerPax', {
                                price: isByAge
                                  ? `RM ${parseMoney(
                                      bookingPrice.priceByAge.child
                                    )}`
                                  : `RM ${parseMoney(
                                      bookingPrice.child_rate[
                                        paxParser(bookingPax.child)
                                      ] / bookingPax.child || 0
                                    )}`
                              })}
                              )<br /> */}
                            </>
                          ) : null}
                          {')'}
                        </span>
                        {/* <span>{t('form:insurance')}{' '}
                          ({t('gen:pricePerPax', {price: `RM ${parseMoney(bookingPrice.insurancePerPax)}`})})
                        </span> */}
                        <span>RM {parseMoney(bookingPrice.insurance)}</span>
                      </div>

                      {/* <div className="fe-menu-summary-price-item">
                        <span>
                          {`${t('form:tax')} (${tax_percentage}%)`}
                        </span>
                        <span>RM {bookingPrice.total * tax_percentage}</span>
                      </div> */}

                      <div className="fe-menu-summary-price-item">
                        <span>
                          {'SST (inclusive of service fees)'}
                        </span>
                        <span>RM {parseMoney(bookingPrice.taxAmount)}</span>
                      </div>

                    </>
                  ) : null }
              </>
            )}
          </div>
        </div>
        <div className={`fe-menu-promo ${isConfirmed ? '' : 'fe-hide'}`}>
          <div className='fe-menu-promo-heading'>{t('form:promoCode')}</div>
          <div className='fe-menu-promo-input'>
            <input
              type='text'
              onChange={e => handleChange(e.target.value)}
              onKeyPress={this.handlePressEnter}
              value={promoCode}
            />
            <Button onClick={applyCode} disabled={isLoading}>
              {isLoading ? `${t('gen:loading')}...` : t('form:apply')}
            </Button>
          </div>
          {newestPromo.message && !isLoading ? (
            <div
              className={`fe-menu-promo-status ${
                !newestPromo.promoValid ? 'invalid' : ''
              }`}
            >
              {newestPromo.message}
            </div>
          ) : null}
        </div>
        {currentTrip.promocode ? (
          <div className='fe-menu-total'>
            <div className="promocode-section">
              <span className='fe-menu-promo-text'>Use the promo code when you check out!</span>
              <div>
                <span className="fe-menu-promo-available">
                  Promo Code Available:
                </span>
                <span className="fe-menu-promocode">
                  {' ' + currentTrip.promocode}
                </span>
              </div>
            </div>
          </div>)
          : null}
        <div className='fe-menu-total'>
          <span className='fe-menu-total-text'>{t('gen:totalPrice')}</span>
          <span className='fe-menu-total-price'>
            {isLoading
              ? `${t('gen:loading')}...`
              : `RM ${parseMoney(tempPrice || bookingPrice.total)}`}
          </span>
        </div>
      </>
    );
  }
}

PriceSummary.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isConfirmed: PropTypes.bool.isRequired,
  bookingPrice: PropTypes.object.isRequired,
  applyCode: PropTypes.func,
  promoCode: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  bookingPax: PropTypes.oneOfType([PropTypes.number, PropTypes.object])
    .isRequired,
  t: PropTypes.func.isRequired,
  isByAge: PropTypes.bool.isRequired,
  isByPax: PropTypes.bool.isRequired,
  isPerTrip: PropTypes.bool.isRequired,
  currentTrip: PropTypes.object.isRequired
};

PriceSummary.defaultProps = {
  isConfirmed: true,
  applyCode: null,
  isPerTrip: false
};

const mapStateToProps = ({ bookingState, authState, tripDetailsState }) => ({
  bookingPrice: bookingState.bookingPrice,
  bookingPax: bookingState.pax,
  loading: bookingState.loading,
  isByAge: bookingState.bookingInfo.isByAge,
  isByPax: bookingState.bookingInfo.isByPax,
  isPerTrip: bookingState.bookingInfo.trip_price.is_per_trip,
  currentTrip: tripDetailsState.currentTrip
});

export default withTranslation()(
  connect(
    mapStateToProps,
    null
  )(PriceSummary)
);
